import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b shadow-sm">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <img 
              src="/images/senegal_flag_1.jpeg" 
              alt="Drapeau du Sénégal" 
              className="w-8 h-6 object-cover rounded"
            />
            <h1 className="text-xl font-bold text-primary">Président Bassirou Diomaye Faye</h1>
          </div>

          {/* Navigation desktop */}
          <nav className="hidden md:flex items-center space-x-6">
            <button 
              onClick={() => scrollToSection('accueil')}
              className="text-foreground hover:text-primary transition-colors"
            >
              Accueil
            </button>
            <button 
              onClick={() => scrollToSection('biographie')}
              className="text-foreground hover:text-primary transition-colors"
            >
              Biographie
            </button>
            <button 
              onClick={() => scrollToSection('parcours')}
              className="text-foreground hover:text-primary transition-colors"
            >
              Parcours
            </button>
            <button 
              onClick={() => scrollToSection('realisations')}
              className="text-foreground hover:text-primary transition-colors"
            >
              Réalisations
            </button>
            <button 
              onClick={() => scrollToSection('vision')}
              className="text-foreground hover:text-primary transition-colors"
            >
              Vision
            </button>
            <button 
              onClick={() => scrollToSection('galerie')}
              className="text-foreground hover:text-primary transition-colors"
            >
              Galerie
            </button>
            <button 
              onClick={() => scrollToSection('discours')}
              className="text-foreground hover:text-primary transition-colors"
            >
              Discours
            </button>
            <button 
              onClick={() => scrollToSection('actualites')}
              className="text-foreground hover:text-primary transition-colors"
            >
              Actualités
            </button>
          </nav>

          {/* Menu mobile */}
          <Button
            variant="ghost"
            size="icon"
            className="md:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </Button>
        </div>

        {/* Menu mobile ouvert */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 border-t pt-4">
            <div className="flex flex-col space-y-3">
              <button 
                onClick={() => scrollToSection('accueil')}
                className="text-left text-foreground hover:text-primary transition-colors"
              >
                Accueil
              </button>
              <button 
                onClick={() => scrollToSection('biographie')}
                className="text-left text-foreground hover:text-primary transition-colors"
              >
                Biographie
              </button>
              <button 
                onClick={() => scrollToSection('parcours')}
                className="text-left text-foreground hover:text-primary transition-colors"
              >
                Parcours
              </button>
              <button 
                onClick={() => scrollToSection('realisations')}
                className="text-left text-foreground hover:text-primary transition-colors"
              >
                Réalisations
              </button>
              <button 
                onClick={() => scrollToSection('vision')}
                className="text-left text-foreground hover:text-primary transition-colors"
              >
                Vision
              </button>
              <button 
                onClick={() => scrollToSection('galerie')}
                className="text-left text-foreground hover:text-primary transition-colors"
              >
                Galerie
              </button>
              <button 
                onClick={() => scrollToSection('discours')}
                className="text-left text-foreground hover:text-primary transition-colors"
              >
                Discours
              </button>
              <button 
                onClick={() => scrollToSection('actualites')}
                className="text-left text-foreground hover:text-primary transition-colors"
              >
                Actualités
              </button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;